var e=!1;function o(){e||("function"!=typeof Promise.withResolvers?(Promise.withResolvers=function(){var e,o;return{promise:new Promise(function(r,i){e=r,o=i}),resolve:e,reject:o}},e=!0):e=!0)}o();export{o as applyPromisePolyfill};
//# sourceMappingURL=index.js.map
